import AxiosClient from "../../../services/axios.services";

class FactorServices {
  getFactor = (params, id) =>
    AxiosClient.get(id ? "/api/app/evaluacion_despliegue_preguntas_factor/" : "/api/app/evaluacion_factor/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  getFactorById = (id) =>
    AxiosClient.get(`/api/app/evaluacion_factor/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveFactor = (data) =>
    AxiosClient.post("/api/app/evaluacion_factor/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editFactor = (id, data, id_encabezado) =>
    AxiosClient.put(id_encabezado ? `/api/app/evaluacion_cambio_pesos_factor/${id_encabezado}/` : `/api/app/evaluacion_factor/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFactor = (id) =>
    AxiosClient.delete(`/api/app/evaluacion_factor/${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new FactorServices();
